import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';
import type { Invoice } from '../api/invoicesApi';

export function InvoicePayment({ onClose }: { item: Invoice; onClose: () => void; onDone: () => void }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Thanh toán hóa đơn')} onClose={onClose} />;
}
